// ##### Komarov 2025-07-21
import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig.js';
// ##### Komarov 2025-07-18
import { useDispatch, useSelector } from 'react-redux';
// ##### Komarov 2025-07-19
import { getPax, setPaxListOpen } from '../../../../../Redux/actions/paxchoice.js';
import HotelsPaxChoiceGrid from './HotelsPaxChoiceGrid.jsx';
import PaxPopUpButton from './PaxPopUpButton.jsx';

// ##### 23-12-27 Komarov

// ##### Komarov 2025-07-14
const PopUp = ({
  style,
  screenIsSmall = false,
  isSecondSearch = false /* , className = '' */,
}) => {
  // ##### Komarov 2025-07-18
  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);
  const { isOnModalDiv, paxListOpen } = useSelector(state => state.paxchoice);

  const dispatch = useDispatch();

  // ##### Komarov 2025-07-18
  const TotalPax = () => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
  };

  return (
    <div
      data-component="PopUp"
      // ##### 24-02-08 Komarov
      className={
        ((!screenIsSmall || isSecondSearch) &&
          (paxListOpen === false
            ? 'PopUpNotActive'
            : 'PopUpActive-HotelsAutocompleteBlock')) ||
        'PopUpActive-HotelsAutocompleteBlock-Mobile'
      }
      // ##### 23-12-27 Komarov
      style={style}
      onClick={e => {
        // ##### Komarov 2025-07-18
        dispatch(setPaxListOpen(true));
        e.stopPropagation();
      }}
      onKeyDown={e => {
        // Trigger click action on Enter key press
        if (e.key === 'Enter') {
          // ##### Komarov 2025-07-18
          dispatch(setPaxListOpen(true));
          e.stopPropagation();
        }
      }}
    >
      {/* ##### 23-11-03 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HotelsPaxChoiceGrid rowGap="10px" />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <HotelsPaxChoiceGrid rowGap="16px" />
      </Media>

      {/* ##### 22-11-08 Komarov - start */}
      {!isOnModalDiv ? (
        <div
          onClick={TotalPax}
          onKeyDown={e => {
            // Trigger click action on Enter key press
            if (e.key === 'Enter') {
              TotalPax(e);
            }
          }}
          style={{ textAlign: 'center' }}
        >
          <Media greaterThanOrEqual="Laptop-1024-1440">
            <PaxPopUpButton marginTop="3vw" />
          </Media>
          <Media lessThan="Laptop-1024-1440">
            <PaxPopUpButton />
          </Media>
        </div>
      ) : null}
      {/* ##### 22-11-08 Komarov - end */}
    </div>
  );
};

export default PopUp;
